<script lang="ts">
  import PureAreaList from "./PureAreaList.svelte";
  import api from "../api";

  export let businessCode: string;
</script>

<PureAreaList endpoint={api.apiBusinessNearbyAreaList(businessCode)} {businessCode} />
